/* eslint class-methods-use-this: 0 */
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { DevicesRepository } from 'common/repositories/index';

const _serviceDependencies = ['$scope', '$stateParams', '$location', '$state', '$filter',
    'DeviceRestService'];

let _$scope;
let _$state;
let _$filter;
let _DeviceRestService;
let _DevicesRepository;
/**
 * @ngdoc service
 * @name controllers.LockDevice
 *
 * @description
 * Lock Device
 */
class LockDevice {

    /**
     * @param  {any} $scope
     * @param  {any} $filter
     * @param  {any} $stateParams
     * @param  {any} $location
     * @param  {any} $state
     * @param  {any} DeviceRestService
     */
    constructor(
        $scope, $stateParams, $location, $state, $filter,
        DeviceRestService,
    ) {

        const deviceId = $stateParams.resourceId;

        if (!deviceId) {

            return $location.path('/dashboard/home');

        }

        _DeviceRestService = DeviceRestService;
        _DevicesRepository = DevicesRepository;

        _$scope = $scope;
        _$filter = $filter;
        _$state = $state;
        _$scope.device = DevicesRepository.getById(deviceId);
        _$scope.brandName = CWCONFIG.partnerConfig.name;

        // $scope assigned function
        _$scope.lockDevice = this.lockDevice;

    }

    lockDevice() {

        const parentState = _$state.current.parent;
        let page = '';

        if (parentState === 'dashboard.devices') {

            page = 'My Devices';

        } else if (parentState === 'dashboard.device-details') {

            page = 'Device Details';

        }

        Mixpanel.send('ConnectWeb Lock Confirm Click', {
            Page: page,
        });

        const devicePayload = {
            data: {
                attributes: {
                    locked: true,
                },
                type: 'devices',
                id: _$scope.device.id,
            },
        };

        _DeviceRestService.update(_$scope.device && _$scope.device.id, devicePayload)
            .then((response) => {

                // update device repository, close modal and alert success
                _DevicesRepository.update(response.data.data);
                _$scope.close();
                Alert.success({
                    message: 'cw.lock_device.success',
                }, {
                    message: {
                        device: _$filter('deviceName')(_$scope.device),
                        brandname: CWCONFIG.partnerConfig.name,
                    },
                });

            }).then(null, () => {

                // close modal and alert error
                _$scope.close();
                Alert.error({
                    message: 'cw.lock_device.error',
                }, {
                    message: {
                        device: _$filter('deviceName')(_$scope.device),
                    },
                });

            });

    }

}

_serviceDependencies.push(LockDevice);

angular.module('controllers')
    .controller('LockDevice', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/device/lock-device/lock-device.js